import { useMemo } from "react";
import VideoCard from "@/components/feature/VideoCard";
import SectionHeading from "@/components/feature/SectionHeading";
import EmptyState from "@/components/feature/EmptyState";
import { videos } from "@/mocks/videos";

export default function LatestVideos() {
  const latest = useMemo(
    () =>
      [...videos]
        .sort((a, b) => new Date(b.uploadDate).getTime() - new Date(a.uploadDate).getTime())
        .slice(0, 9),
    []
  );

  return (
    <section>
      <SectionHeading
        title="最新视频推荐"
        subtitle="按上传时间倒序，第一时间发现新上线的内容"
        href="/category/short-video"
        linkText="进入分类"
      />
      {latest.length === 0 ? (
        <EmptyState message="暂无相关内容，敬请期待" />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-7">
          {latest.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      )}
    </section>
  );
}